<template>
  <q-dialog persistent ref="dialog" @hide="onDialogHide">
    <q-card class="q-dialog-plugin">
      <q-card-section>
        <template>
          <div class="text-h6">Reorder</div>
          <p>Add products to your current selected customer cart?</p>
          <p class="warnning text-accent">
            If this is not the shopping cart you want. Please select the
            customer you want.
          </p>
        </template>
      </q-card-section>
      <q-separator></q-separator>
      <q-card-section class="row">
        <div class="col-12 row justify-between">
          <p>Product list</p>
          <q-btn-group>
            <q-btn
              dense
              color="primary"
              no-caps
              no-wrap
              @click="selected = products"
              >Select all</q-btn
            >
            <q-separator vertical></q-separator>
            <q-btn dense color="primary" no-caps no-wrap @click="selected = []"
              >Remove all</q-btn
            >
          </q-btn-group>
        </div>
        <div class="col-12">
          <q-item dense v-for="(product, index) in products" :key="index">
            <q-item-section>
              <q-checkbox
                v-model="selected"
                :val="product"
                :label="`${product.productName} ${product.productBrand}`"
              />
            </q-item-section>
          </q-item>
        </div>
      </q-card-section>
      <q-card-actions align="right">
        <q-btn color="primary" label="OK" @click="onOKClick" />
        <q-btn color="primary" label="Cancel" @click="onCancelClick" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  props: {
    // ...your custom props
    products: Array,
  },
  emits: [
    // REQUIRED
    "ok",
    "hide",
  ],
  data() {
    return {
      selected: [],
    };
  },
  mounted() {
    this.selected = this.products;
  },
  methods: {
    // following method is REQUIRED
    // (don't change its name --> "show")
    show() {
      this.$refs.dialog.show();
    },

    // following method is REQUIRED
    // (don't change its name --> "hide")
    hide() {
      this.$refs.dialog.hide();
    },

    onDialogHide() {
      // required to be emitted
      // when QDialog emits "hide" event
      this.$emit("hide");
    },

    onOKClick() {
      // on OK, it is REQUIRED to
      // emit "ok" event (with optional payload)
      // before hiding the QDialog
      this.$emit("ok", this.selected);
      // or with payload: this.$emit('ok', { ... })

      // then hiding dialog
      this.hide();
    },

    onCancelClick() {
      // we just need to hide the dialog
      this.hide();
    },
  },
};
</script>

<style scoped>

p {
  padding: 0;
  margin: 0;
}
.warning {
}
.q-dialog-plugin {
  width: 100%;
  max-width: 600px;
}

</style>